module.exports = __webpack_public_path__ + "img/jgxq.2b6ae747.png";